import { Language } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import moment from 'moment';
export var DateSuffix;
(function (DateSuffix) {
    DateSuffix["MINUTES"] = "MINUTES";
    DateSuffix["SECONDS"] = "SECONDS";
})(DateSuffix || (DateSuffix = {}));
export function formatDate(date, language, suffix) {
    var format = language === Language.FR ? 'DD/MM/YYYY' : 'YYYY/MM/DD';
    if (suffix === DateSuffix.MINUTES)
        format += ' HH:mm';
    if (suffix === DateSuffix.SECONDS)
        format += ' HH:mm:ss';
    return moment(date).format(format);
}
